<template>
  <b-modal
    v-model="editorShown"
    title="Request Documents"
    centered
    size="md"
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="white"
    header-class="bg-purple"
  >
    <b-row>
      <b-col>
        <b-form-group
          label="Select groups or forms to send:"
          class="text-left mb-2"
        >
          <b-form-input placeholder="Search" v-model="search"></b-form-input>
        </b-form-group>

        <b-list-group class="form-options mb-2">
          <b-form-checkbox-group
            v-if="categories.includes('main')"
            v-model="selectedFormGroups"
            stacked
          >
            <b-list-group-item
              :variant="
                selectedFormGroups.indexOf(formGroup.id) >= 0 ? 'primary' : ''
              "
              v-for="formGroup in filteredFormGroups"
              :key="formGroup.id"
              class="p-2"
            >
              <b-form-checkbox :value="formGroup.id">
                <span
                  class="text-primary font-weight-bold"
                  style="font-size:14px;"
                  ><b-icon-files class="mr-2" />{{ formGroup.name }}</span
                >
              </b-form-checkbox>
              <div
                v-if="selectedFormGroups.indexOf(formGroup.id) >= 0"
                style="display: flex; margin-left: 23px; margin-top: 3px; margin-bottom: 3px;"
              >
                <vue-toggles
                  @click="updateFormsSelected(formGroup)"
                  :value="formGroup.requestUpload"
                  height="18"
                  width="30"
                  checkedBg="#34C759"
                  uncheckedBg="#FF6161"
                />
                <div style="font-size: 13px; margin-left:5px;">
                  Request this document as <strong>File Upload</strong>
                </div>
              </div>
            </b-list-group-item>
          </b-form-checkbox-group>
          <b-form-checkbox-group v-model="selectedForms" stacked>
            <b-list-group-item
              v-for="form in filteredForms"
              :key="form.id"
              class="p-2"
              :variant="
                selectedForms.indexOf(form.id) >= 0 ||
                hasFormGroupSelected(form.id)
                  ? 'primary'
                  : ''
              "
            >
              <div class="d-flex flex-row justify-content-between">
                <b-form-checkbox
                  class="w-100"
                  :value="form.id"
                  :disabled="hasFormGroupSelected(form.id)"
                >
                  <span style="font-size:14px;">{{ form.name }}</span>
                </b-form-checkbox>
                <span
                  style="width:64px; font-size: 14px;"
                  v-if="hasFormGroupSelected(form.id)"
                >
                  Included
                </span>
              </div>
              <div
                v-if="selectedForms.indexOf(form.id) >= 0"
                style="display: flex; margin-left: 23px; margin-top: 3px; margin-bottom: 3px;"
              >
                <vue-toggles
                  @click="changeFormRequestUpload(form)"
                  :value="form.requestUpload"
                  height="18"
                  width="30"
                  checkedBg="#34C759"
                  uncheckedBg="#FF6161"
                />
                <div style="font-size: 13px; margin-left:5px;">
                  Request this document as <strong>File Upload</strong>
                </div>
              </div>
            </b-list-group-item>
          </b-form-checkbox-group>
        </b-list-group>

        <b-form-group label="Portal Account">
          <v-select :options="portalAccesses" v-model="portalAccessId" />
        </b-form-group>
      </b-col>
    </b-row>

    <template v-slot:modal-footer>
      <div class="text-right mt-1 mr-2">
        <b-button @click.prevent="onHidden" variant="secondary">
          Cancel
        </b-button>
        <b-button
          class="ml-2"
          variant="primary"
          @click.prevent="sendLink"
          :disabled="
            (selectedFormGroups.length == 0 && selectedForms.length == 0) ||
              portalAccessId == null
          "
        >
          Send
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import { mapState, mapActions, mapGetters } from "vuex";
import portalAccessServer from "../../../server/portalAccess";
import portalDocumentServer from "../../../server/portalDocument";

export default {
  name: "EFormSendMultipleModal",
  props: ["patientId", "eocId", "categories"],
  data() {
    return {
      search: "",
      selectedForms: [],
      selectedFormGroups: [],
      portalAccessId: null,
      portalAccesses: []
    };
  },
  async mounted() {
    this.fetchFormGroups();
    for (let index = 0; index < this.categories.length; index++) {
      const category = this.categories[index];
      this.fetchFormBuilderForms({ category: category });
    }

    const portalAccounts = await portalAccessServer.findAllAccess(
      this.patientId
    );
    this.portalAccesses = portalAccounts.map(access => ({
      value: access.id,
      label: `${access.name} (${access.relationship})`
    }));
    if (this.portalAccesses.length == 1) {
      this.portalAccessId = this.portalAccesses[0];
    }
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess"]),
    ...mapActions("formGroup", ["fetchFormGroups"]),
    ...mapActions("formBuilder", ["fetchFormBuilderForms"]),
    async sendLink() {
      var formsUpload = {};
      [...this.selectedForms, ...this.selectedFormGroups].forEach(formId => {
        const form = [...this.forms, ...this.formGroups].find(
          f => f.id == formId
        );
        formsUpload[formId] = form?.requestUpload;
      });
      await portalDocumentServer.sharePatientForms({
        portalAccessIds: [this.portalAccessId.value],
        formIds: [...this.selectedForms, ...this.selectedFormGroups],
        episodeOfCareId: this.eocId,
        formsUploadRequest: formsUpload
      });
      this.$emit("onModify");
      this.showAlertSuccess();
    },
    onHidden() {
      this.$emit("onModify");
    },
    hasFormGroupSelected(formId) {
      let inFormGroup = false;
      for (let index = 0; index < this.selectedFormGroups.length; index++) {
        const formGroupId = this.selectedFormGroups[index];
        const formGroup = this.formGroups.find(fg => fg.id == formGroupId);
        if (formGroup.formIds.indexOf(formId) >= 0) inFormGroup = true;
      }
      return inFormGroup;
    },
    changeFormRequestUpload(form) {
      if (!this.hasFormGroupSelected(form.id)) {
        form.requestUpload = !form.requestUpload;
      }
    },
    updateFormsSelected(formGroup) {
      formGroup.requestUpload = !formGroup.requestUpload;
      this.forms.forEach(form => {
        if (formGroup.formIds.indexOf(form.id) >= 0) {
          form.requestUpload = formGroup.requestUpload;
        }
      });
    }
  },
  computed: {
    ...mapState("formBuilder", {
      allForms: state => state.list
    }),
    ...mapGetters("client", ["formsCurrentLocation"]),
    ...mapGetters("client", ["formGroupsCurrentLocation"]),
    ...mapGetters("layout", ["hasCurrentUserDocumentPermission"]),
    forms() {
      let forms = [];
      for (let index = 0; index < this.categories.length; index++) {
        const category = this.categories[index];
        forms = [...forms, ...this.allForms[category]];
      }
      return this.formsCurrentLocation.filter(
        f =>
          this.hasCurrentUserDocumentPermission(f.id, "isReadOnly") &&
          forms.find(fi => fi.id == f.id)
      );
    },
    formGroups() {
      return this.formGroupsCurrentLocation.filter(f =>
        this.hasCurrentUserDocumentPermission(f.id, "isReadOnly")
      );
    },
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    filteredFormGroups() {
      return this.formGroups
        .filter(
          fB =>
            !this.search ||
            fB.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        )
        .sort((fB1, fB2) => fB1.name.localeCompare(fB2.name));
    },
    filteredForms() {
      return this.forms
        .filter(
          f =>
            !this.search ||
            f.name.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        )
        .sort((f1, f2) => f1.name.localeCompare(f2.name));
    }
  },
  watch: {
    selectedFormGroups: function(formGroupIds, prevFormGroupIds) {
      const formGroups = this.formGroups.filter(
        fg => formGroupIds.indexOf(fg.id) >= 0
      );
      for (let index = 0; index < formGroups.length; index++) {
        const formGroup = formGroups[index];
        for (let index2 = 0; index2 < formGroup.formIds.length; index2++) {
          const formId = formGroup.formIds[index2];
          if (this.selectedForms.indexOf(formId) == -1)
            this.selectedForms.push(formId);
        }
      }
      for (let index = 0; index < prevFormGroupIds.length; index++) {
        const prevFormGroupId = prevFormGroupIds[index];
        if (formGroupIds.indexOf(prevFormGroupId) == -1) {
          const formGroup = this.formGroups.find(
            fg => fg.id == prevFormGroupId
          );
          for (let index2 = 0; index2 < formGroup.formIds.length; index2++) {
            const formId = formGroup.formIds[index2];
            if (this.selectedForms.indexOf(formId) >= 0) {
              const newSelectedForms = [...this.selectedForms];
              newSelectedForms.splice(this.selectedForms.indexOf(formId), 1);
              this.selectedForms = newSelectedForms;
            }
          }
        }
      }
    }
  }
};
</script>

<style scoped>
.prepend-send {
  width: 170px;
}
.form-options {
  height: 250px;
  overflow-y: auto;
}
</style>
